export enum ClipboardTypes {
  CLIPBOARD__CLEAR = 'CLIPBOARD__CLEAR',
  CLIPBOARD__COPY = 'CLIPBOARD__COPY',
}
